"use strict";
/*------------------------------------------------------------|
 * Contains everything which is given by the user as input.
 *-----------------------------------------------------------*/
Object.defineProperty(exports, "__esModule", { value: true });
